module.exports = __webpack_public_path__ + "images/ducati9d0b69d0c535bc1102c0cf3024751ac9.png";